module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('p', [_vm._v("If you would like XMission to contact you about adding phone services, please check the box below.")]), _vm._v(" "), _c('b-form-checkbox', {
    model: {
      value: (_vm.form_data.contact),
      callback: function($$v) {
        _vm.$set(_vm.form_data, "contact", $$v)
      },
      expression: "form_data.contact"
    }
  }, [_vm._v("Contact me about setting up XMission Voice on my connectivity service")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Additional Voice services")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc7c760","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/create/VoiceService.vue
// module id = 1334
// module chunks = 16